import React from 'react';
import { ChevronLeft } from 'lucide-react';
interface NavItemProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: (id: string) => void;
  isSubItem?: boolean;
}
function NavItem({
  id,
  label,
  isActive,
  onClick,
  isSubItem = false
}: NavItemProps) {
  return <button onClick={() => onClick(id)} className={`w-full text-left block py-2 text-sm transition-colors ${isSubItem ? 'pl-8 pr-4' : 'px-4'} ${isActive ? 'text-[#0B5FA5] border-l-4 border-[#0B5FA5] bg-blue-50/50 font-medium' : 'text-gray-600 hover:text-[#0B5FA5] hover:bg-blue-50/30 border-l-4 border-transparent'}`} data-id="element-138">
      {label}
    </button>;
}
interface CheckoutSidebarProps {
  activePage: string;
  onNavigate: (pageId: string) => void;
}
export function CheckoutSidebar({
  activePage,
  onNavigate
}: CheckoutSidebarProps) {
  return <aside className="w-[260px] flex-shrink-0 border-r border-gray-200 bg-[#F8FAFC] flex flex-col h-screen sticky top-0 overflow-y-auto" data-id="element-139">
      <div className="p-4 sticky top-0 bg-[#F8FAFC] z-10 border-b border-gray-200" data-id="element-140">
        <button onClick={() => onNavigate('overview')} className="flex items-center text-sm font-semibold text-gray-700 hover:text-[#0B5FA5] transition-colors" data-id="element-141">
          <ChevronLeft className="w-4 h-4 mr-1" data-id="element-142" />
          Back to Overview
        </button>
      </div>

      <nav className="flex-1 py-4 pb-12" data-id="element-143">
        <div className="space-y-0.5" data-id="element-144">
          <NavItem id="checkout" label="<<checkout>>" isActive={activePage === 'checkout'} onClick={onNavigate} data-id="element-145" />
          <NavItem id="checkout-integration-steps" label="Integration Steps" isActive={activePage === 'checkout-integration-steps'} onClick={onNavigate} data-id="element-146" />
          <NavItem id="checkout-session" label="Establishing a Session" isActive={activePage === 'checkout-session'} onClick={onNavigate} data-id="element-147" />
          <NavItem id="checkout-hosted-payment-page" label="Implementing the <<hostedPaymentPage>>" isActive={activePage === 'checkout-hosted-payment-page'} onClick={onNavigate} data-id="element-148" />
          <NavItem id="checkout-subsequent-ops" label="Subsequent Operations" isActive={activePage === 'checkout-subsequent-ops'} onClick={onNavigate} data-id="element-149" />
          <NavItem id="checkout-response" label="Interpreting the Response" isActive={activePage === 'checkout-response'} onClick={onNavigate} data-id="element-150" />
          <NavItem id="checkout-customizing" label="Customizing the Checkout" isActive={activePage === 'checkout-customizing'} onClick={onNavigate} data-id="element-151" />
          <NavItem id="checkout-features" label="Features" isActive={activePage === 'checkout-features'} onClick={onNavigate} data-id="element-152" />
          <NavItem id="checkout-browsers" label="Supported Browsers and Platforms" isActive={activePage === 'checkout-browsers'} onClick={onNavigate} data-id="element-153" />
          <NavItem id="checkout-testing" label="Testing Steps" isActive={activePage === 'checkout-testing'} onClick={onNavigate} data-id="element-154" />
          <NavItem id="checkout-go-live" label="Go-Live Checklist" isActive={activePage === 'checkout-go-live'} onClick={onNavigate} data-id="element-155" />
        </div>
      </nav>
    </aside>;
}